import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Onboarding from './pages/Onboarding';
import Home from './pages/Home';
import Stage from './pages/Stage';
import PostDetail from './pages/PostDetail';
import GreenRoom from './pages/GreenRoom';
import Toolkit from './pages/Toolkit';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Transparency from './pages/Transparency';
import ModDashboard from './pages/ModDashboard';
import AdminDashboard from './pages/AdminDashboard';
import GhostHours from './pages/GhostHours';
import Settings from './pages/Settings';
import Landing from './pages/Landing';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const [onboarded, setOnboarded] = useState(() => localStorage.getItem('gl_onboarded') === 'true');

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0e0a08', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontFamily: '"Instrument Serif", serif', fontSize: 21, color: '#e8b547', opacity: 0.6, animation: 'gl-breathe 3.5s ease-in-out infinite' }}>GhostLight</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/welcome" />;

  if (!onboarded) {
    return <Onboarding onComplete={() => { localStorage.setItem('gl_onboarded', 'true'); setOnboarded(true); }} />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0e0a08', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontFamily: '"Instrument Serif", serif', fontSize: 21, color: '#e8b547', opacity: 0.6, animation: 'gl-breathe 3.5s ease-in-out infinite' }}>GhostLight</p>
      </div>
    );
  }
  return user ? <Navigate to="/" /> : children;
}

function CatchAllRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" /> : <Navigate to="/welcome" />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/welcome" element={<Landing />} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/transparency" element={<Transparency />} />
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/stage" element={<PrivateRoute><Stage /></PrivateRoute>} />
          <Route path="/post/:id" element={<PrivateRoute><PostDetail /></PrivateRoute>} />
          <Route path="/green-room" element={<PrivateRoute><GreenRoom /></PrivateRoute>} />
          <Route path="/toolkit" element={<PrivateRoute><Toolkit /></PrivateRoute>} />
          <Route path="/ghost-hours" element={<PrivateRoute><GhostHours /></PrivateRoute>} />
          <Route path="/mod" element={<PrivateRoute><ModDashboard /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="*" element={<CatchAllRoute />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
